var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect } from 'react';
import UserItem from './utils/UserItem';
import { UserListTitle, UserListWrapper } from './utils/subcomponents';
import { PAGE_NAME, SAMS_PAGE_NAME } from '../../../const/analytics';
import triggerManageCardHoldersAnalytics from '../../../helpers/trigger-manage-card-holders-analytics';
import triggerManageCardHoldersSamsAnalytics from '../../../helpers/trigger-manage-card-holders-sams-analytics';
import NoManageCardHoldersAdded from './utils/NoManageCardHoldersAdded';
import { CardholdersScreen } from '../../../typings';
import MaximumMessageBox from '../MaximumMessageBox';
import { translate } from '../../../strings/i18n';
var AuthorizedUsers = function (_a) {
    var authorizedUsers = _a.authorizedUsers, remainingAuthUserAllowed = _a.remainingAuthUserAllowed, currentScreen = _a.currentScreen, _b = _a.isSamsClient, isSamsClient = _b === void 0 ? false : _b;
    var isNewUserConfirmation = currentScreen === CardholdersScreen.CONFIRMATION_SCREEN_NEW_USER;
    var authorizedUsersData = authorizedUsers && (authorizedUsers === null || authorizedUsers === void 0 ? void 0 : authorizedUsers.authorizedUsers);
    var hasEmptyAuthorizedUsersData = !(authorizedUsersData === null || authorizedUsersData === void 0 ? void 0 : authorizedUsersData.length);
    var hasReachedMaximumLimit = remainingAuthUserAllowed &&
        remainingAuthUserAllowed === '0' &&
        !isNewUserConfirmation;
    useEffect(function () {
        if (isSamsClient) {
            if (isNewUserConfirmation) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.SUCCESS
                });
            }
            else if (hasReachedMaximumLimit) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.LIMIT_REACHED,
                    errorMessage: 'you have reached the maximum number of authorized users'
                });
            }
            else if (currentScreen === CardholdersScreen.INITIAL_SCREEN) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.START_VERIFIED
                });
            }
            else if (currentScreen === CardholdersScreen.VERIFY_USER_SCREEN) {
                triggerManageCardHoldersSamsAnalytics({
                    pageName: SAMS_PAGE_NAME.NOT_VERIFIED
                });
            }
        }
        else if (isNewUserConfirmation) {
            triggerManageCardHoldersAnalytics({
                pageName: PAGE_NAME.COMPLETE
            });
        }
        else if (hasReachedMaximumLimit) {
            triggerManageCardHoldersAnalytics({
                pageName: PAGE_NAME.LIMIT_REACHED
            });
        }
        else if (currentScreen === CardholdersScreen.INITIAL_SCREEN) {
            triggerManageCardHoldersAnalytics({
                pageName: PAGE_NAME.START
            });
        }
    }, [
        currentScreen,
        hasReachedMaximumLimit,
        isNewUserConfirmation,
        isSamsClient
    ]);
    return (_jsxs(_Fragment, { children: [hasEmptyAuthorizedUsersData && _jsx(NoManageCardHoldersAdded, {}), hasReachedMaximumLimit && _jsx(MaximumMessageBox, {}), _jsxs(UserListWrapper, __assign({ vertical: "xlarge", "data-testid": "authorized-users", top: "base" }, { children: [isNewUserConfirmation && (_jsx(UserListTitle, __assign({ weight: "light", isInline: true }, { children: translate('newAuthorizedUser.title') }))), authorizedUsersData === null || authorizedUsersData === void 0 ? void 0 : authorizedUsersData.map(function (usersDetails) {
                        return (_jsx(UserItem, { name: "".concat(usersDetails['cipher.firstName'], " ").concat(usersDetails['cipher.lastName']), isNewUserConfirmation: isNewUserConfirmation }, usersDetails.authorizedUserId));
                    })] }))] }));
};
export default AuthorizedUsers;
